import React, {Component} from "react";
import ModalContainer from "../../../../../modules/commons/ModalContainer";
import SimpleInput from "../../../../../modules/SimpleInput";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import SimpleModal from "../../../../../modules/popup/SimpleModal";
import withFormGroup from "../../../../../modules/commons/withFormGroup";

class MasterLogistikMotorSegmenModifying extends Component {
    handleSubmit = (e) => {
        e.preventDefault();
        if (this.props.validate()) {
            this.props.onSubmit(this.props.controls);
        }
    };

    render() {
        return (
            <SimpleModal
                title="Form Segmen"
                visible={this.props.visible}
                onClickClose={() => this.props.onClickClose()}
                content={
                    <ModalContainer>
                        <form onSubmit={this.handleSubmit}>
                            <SimpleInput
                                id="input_text_segmenid"
                                name="id"
                                label="Segmen ID"
                                value={this.props.controls.id.value}
                                readOnly
                            />
                            <SimpleInput
                                id="input_text_namasegmen"
                                name="segmentName"
                                label="Nama Segmen"
                                mandatory
                                errorMessage={this.props.errors.segmentName}
                                value={this.props.controls.segmentName.value}
                                onChange={({target}) =>
                                    this.props.setValue(target.name, target.value)
                                }
                            />
                            <div style={{textAlign: "center"}}>
                                <SimpleButton type="submit">Simpan</SimpleButton>
                            </div>
                        </form>

                    </ModalContainer>
                }
            />
        )
    }
}

export default withFormGroup(MasterLogistikMotorSegmenModifying);